import { editBankAccount, relinkBankAccount } from '../constants';

// Helper to determine if the current redirectUrl after OAuth login contains a refUrl parameter
export const extractRefUrlFromCurrentUrl = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const currentUrl = window.location.href;
    // Check if we're in an OAuth flow with a redirectUrl parameter
    if (currentUrl.includes('/oauth/social') && currentUrl.includes('redirectUrl=')) {
      const url = new URL(currentUrl);
      const redirectUrlParam = url.searchParams.get('redirectUrl');

      if (redirectUrlParam) {
        // Decode the redirectUrl and extract refUrl from it
        const decodedRedirectUrl = decodeURIComponent(redirectUrlParam);
        const redirectUrl = new URL(decodedRedirectUrl);
        return redirectUrl.searchParams.get('refUrl');
      }
    }
    // Fallback: check current URL for refUrl parameter
    const currentUrlObj = new URL(currentUrl);
    return currentUrlObj.searchParams.get('refUrl');
  } catch (error) {
    return null;
  }
};

export const isRelinkOrEditBankAccountEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    return (
      url.searchParams.get('step') === relinkBankAccount ||
      url.searchParams.get('step') === editBankAccount ||
      url.searchParams.get('oauth_state_id') !== null
    );
  } catch (error) {
    return false;
  }
};
